import React from "react";
import { Dialog } from "@headlessui/react";
import del from "./img/del.png";
import errorIcon from "./img/error-icon.svg";
import Styles from "./Styles.module.css";

export const ErrorModal = ({ setErrorModalShow, isErrrModalShow }) => {
  const handleClose = () => {
    setErrorModalShow(null);
    window.location.reload();
  };

  const handleRedirect = () => {
    setErrorModalShow(null);
    window.location.replace("/");
  };

  return (
    <Dialog
      open={true}
      onClose={() => setErrorModalShow(null)}
      className={Styles.containerBox}
    >
      <div className="min-h-screen px-4 text-center">
        <div className={Styles.overlay}></div>
        <Dialog.Panel className={Styles.dialogPanel}>
          <button className={Styles.xButton} onClick={handleClose}>
            <img src={del} alt="Close" />
          </button>

          <Dialog.Title as="h3" className={Styles.modalTitle}>
            <img src={errorIcon} alt="Error" className={Styles.errorIcon} />
            {isErrrModalShow?.message || "An error occurred"}
          </Dialog.Title>

          <div className="mt-4 flex justify-end">
            <button
              type="button"
              className={Styles.buttonComponent}
              onClick={handleRedirect}
            >
              OK
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
